import React, { useEffect } from "react";
import { Button } from "@mui/material";
import Slider from "react-slick";
import tg from "../images/tg.svg";
import tel from "../images/tel.svg";
import insta from "../images/insta.svg";
import { useTranslation } from "react-i18next";
import RoundedCircleText from "./RoundedCircleText";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IMG_URL } from "../../api/imgApi/ImgApi";

const Main = () => {
  const { t, ready } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");
  const [mainClient, mainData, mainStatus, mainError] = useRequest();

  const settings: any = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1200,
    slidesToShow: 1,
    pauseOnHover: false,
    slidesToScroll: 1,
    appendDots: (dots: any) => (
      <div className="slickDots">
        <ul className="oneDot"> {dots} </ul>
      </div>
    ),
    customPaging: (i: any) => <div className="myDot"></div>,
  };

  const getBanners = async () => {
    await mainClient.get("banner");
  };

  useEffect(() => {
    getBanners();
  }, []);

  return (
    <div className="asosiy_container" id="asosiy">
      <div className="asosiy_left">
        <div className="asosiy_texts">
          <div
            data-aos="fade-right"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="500"
          >
            {lang === "eng" ? (
              <h2>
                {t("MAINPAGE.TITLEONE")}
                <br />
                {t("MAINPAGE.TITLETWO")}
                <span> {t("MAINPAGE.TITLETHREE")} </span>
              </h2>
            ) : lang === "ru" ? (
              <h2 className={lang === "ru" ? "active" : ""}>
                {t("MAINPAGE.TITLEONE")}
                <br />
                {t("MAINPAGE.TITLETWO")}
                <span> {t("MAINPAGE.TITLETHREE")} </span>
              </h2>
            ) : (
              <h2>
                {t("MAINPAGE.TITLEONE")}
                <br />
                <span> {t("MAINPAGE.TITLETHREE")} </span>
                {t("MAINPAGE.TITLETWO")}
              </h2>
            )}
          </div>

          <div
            data-aos="fade-right"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="600"
          >
            <p className="main_text">{t("MAINPAGE.DESCRIPTION")}</p>
          </div>
        </div>

        <div
          data-aos="fade-left"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="700"
        >
          <div className="main_btns">
            <a href="#product" className="mahsulot_btn">
              <Button className="my_btn">{t("MAINPAGE.PRODUCT")}</Button>
            </a>
            <Button className="my_btn_social_link">
              <a
                href="https://t.me/yuksalish_socks"
                className="social_main_link"
                target="_blank"
              >
                <img src={tg} alt="tg" />
              </a>
              <a href="tel:+998992292020" className="social_main_link">
                <img src={tel} alt="tg" />
              </a>
              <a
                href="https://www.instagram.com/yuksalish_socks/"
                className="social_main_link"
                target="_blank"
              >
                <img src={insta} alt="tg" />
              </a>
            </Button>
          </div>
        </div>
      </div>

      <a href="#imkoniyat" className="default_circleText_box">
        <div className="circle">
          <div className="circle_icon"></div>
          <RoundedCircleText text={t("MAINPAGE.TOBOTTOM")} />
        </div>
      </a>

      <div className="asosiy_right">
        <Slider {...settings} className="slide">
          {mainData?.data?.map((item: any) => (
            <div className="asosiy_img_box" key={item._id}>
              <LazyLoadImage
                alt="product"
                effect="blur"
                src={IMG_URL + item.imageUrl}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Main;
